import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageInterceptor } from './core/interceptors/language.interceptor';
import { LoaingInterceptor } from './core/interceptors/loading.interceptor';
import { AgmCoreModule } from '@agm/core';
import { provideToastr } from 'ngx-toastr';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export const appConfig: ApplicationConfig = {
  providers: [
     provideRouter(routes),
    importProvidersFrom(AgmCoreModule.forRoot({
      apiKey: 'https://maps.google.com/maps/api/js?key=AIzaSyAIcQUxj9rT_a3_5GhMp-i6xVqMrtasqws&language=ar&callback=initM&v=weekly'
    })),
     provideClientHydration(),
     provideHttpClient(withFetch()),
     provideHttpClient(withInterceptorsFromDi()),
     provideAnimations(),  // Required for animations in Angular 17
     provideToastr({  // Configure ngx-toastr globally
       timeOut: 3000,
       positionClass: 'toast-top-right',
       preventDuplicates: true
     }),
     [
      {provide:HTTP_INTERCEPTORS,useClass:ErrorInterceptor,multi:true},
      {provide:HTTP_INTERCEPTORS,useClass:JwtInterceptor,multi:true},
      {provide:HTTP_INTERCEPTORS,useClass:LoaingInterceptor,multi:true},
      {provide:HTTP_INTERCEPTORS,useClass:LanguageInterceptor,multi:true},
    ],
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      BrowserAnimationsModule

  ])
],

};
